import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {localization} from '../../Frames/localization'
import {convert} from '../../Frames/convert'

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';

const useStyles = makeStyles({
    tableWrapper: {
      minHeight: 590,
      maxHeight: 590,
      overflow: 'auto',
    },
    });
  function Data(props)
    {
     var rows = 
        props.data.incomeFuelHistory.map(item => (
          createData(item.operationDate, item.skuQuantity, item.amount)
        ))
    
      return rows;
    }
  function createData(date, quantity, sum) {
    return { date, quantity, sum };
  }
  
  export default function SimpleTable(props) {
    const classes = useStyles();
    const rows = Data(props)
    var tr = {
      date: localization.GetTranslate('Statistics.Date'),
      quantity: localization.GetTranslate('Statistics.Number'),
      sum: localization.GetTranslate('Statistics.sum'),
      of: localization.GetTranslate('Statistics.of')
    }

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(props.AppliedSettings.statistics_scroll_num);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
    return (
        <div className={props.className}>
          <div className={classes.tableWrapper}>
                <Table className={classes.table} aria-label="simple table">
                <TableHead>
                    <TableRow>
                    <TableCell>{tr.date}</TableCell>
                    <TableCell align="center">{tr.quantity}</TableCell>
                    <TableCell align="center">{tr.sum}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => {
                  return (
                    <TableRow>
                        <TableCell align="left" component="th" scope="row">{convert.timestampToDateTimeStr(row.date)}</TableCell>
                        <TableCell align="center">{row.quantity}</TableCell>
                        <TableCell align="center">{row.sum}</TableCell>
                    </TableRow>
                    );
                  })}
                </TableBody>
                </Table>
                </div>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={rows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  labelRowsPerPage={tr.quantity}
                  backIconButtonProps={{
                    'aria-label': 'previous page',
                  }}
                  labelDisplayedRows={({ from, to, count }) => `${from}-${to} ${tr.of} ${count}`}
                  nextIconButtonProps={{
                    'aria-label': 'next page',
                  }}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}  
                  classes={{
                    root: "rootPagination",
                    caption: "rootPagination",
                    selectIcon: "rootPagination",
                    select: "rootPagination",
                    actions: "rootPagination",
                  }}
                />
      </div>
    );
  }